// extracted by mini-css-extract-plugin
export default {"spinner":"LoadingSpinner_spinner__Nekz0","ldsRoller":"LoadingSpinner_ldsRoller__DbIX4"};